import {
	generalInfoConstants
} from './generalInfo.constants';
import {
	generalInfoService
} from 'services';

export const generalInfoActions = {
	sendGeneralInfo,
	getApplicationId
};

function sendGeneralInfo(payload) {
	return (dispatch) => {
		dispatch(request());
		return generalInfoService.sendGeneralInfo(payload)
			.then(
				result => {
					dispatch(success(result))
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error))
					return Promise.reject(error);
				}
			);
	};

	function request() {
		return {
			type: generalInfoConstants.SEND_GENERAL_INFO_REQUEST,
		};
	}

	function success(result) {
		return {
			type: generalInfoConstants.SEND_GENERAL_INFO_SUCCESS,
		};
	}

	function failure(error) {
		return {
			type: generalInfoConstants.SEND_GENERAL_INFO_ERROR,
			error,
		};
	}
}

function getApplicationId(token) {
	return (dispatch) => {
		dispatch(request());
		return generalInfoService.getApplicationId(token)
			.then(
				result => {
					dispatch(success(result))
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error))
					return Promise.reject(error);
				}
			);
	};

	function request() {
		return {
			type: generalInfoConstants.GET_APPLICATION_ID_REQUEST,
		};
	}

	function success(result) {
		return {
			type: generalInfoConstants.GET_APPLICATION_ID_SUCCESS,
			result,
		};
	}

	function failure(error) {
		return {
			type: generalInfoConstants.GET_APPLICATION_ID_ERROR,
			error,
		};
	}
}